<template>
  <div class="route-legend-wrapper position-relative">
    <button class="route-legend-btn" :class="{ active: visible }" @click="visible = !visible">
      {{ $t('flexigo.ridership.legendForRouteColors') }}
    </button>
    <div v-if="visible" class="route-legend-popup">
      <div v-for="(color, name) in colorMap" :key="name" class="legend-item">
        <span class="legend-swatch" :style="{ backgroundColor: color }" />
        <span class="legend-label">{{ name }}</span>
      </div>
      <div v-if="!Object.keys(colorMap).length" class="text-muted small p-2">
        {{ $t('flexigo.ridership.noData') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouteLegend',

  props: {
    colorMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.onDocumentClick = (event) => {
      if (this.visible && !this.$el.contains(event.target)) {
        this.visible = false;
      }
    };
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
};
</script>

<style scoped>
/* Zeplin ButtonPrimaryActive: charcoal-grey fill, white text, 4px radius.
   https://zpl.io/GnpdEk9 — design token: charcoal-grey rgb(54, 54, 71) */
.route-legend-btn {
  background: #fff;
  color: #363647;
  border: 1px solid #363647;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.route-legend-btn:hover {
  background: #363647;
  color: #fff;
}

.route-legend-btn.active {
  background: #363647;
  color: #fff;
}

.route-legend-popup {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 100;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 12px;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  margin: 0 -6px;
  font-size: 12px;
  border-radius: 4px;
  transition: background 0.15s;
}

.legend-item:hover {
  background: #f0f3ff;
}

.legend-swatch {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
